module.exports = __webpack_public_path__ + "img/logo.66eab6c0.png";